module.exports = __webpack_public_path__ + "static/showcase-tile-02-6ad6daa1369fc2d36ddf8678ff37ff14.jpg";